<template>
  <v-container>
    <div
      v-if="!Loading">
      <v-row justify="center">
        <v-col md="10">
          <v-container>
            <v-card>
              <v-toolbar
                color="primary"
                dark>
                <v-toolbar-title>
                  <v-icon>star</v-icon>リクエストを見る
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <span
                  v-if="this.requests.length() != 0"
                  class="text--primary">
                  以下の承認リクエストがあります。
                </span>
                <span
                  v-else
                  class="text--primary">
                  現在リクエストはありません。
                </span>
                <v-dialog
                  v-model="dialog"
                  persistent
                  max-width="600px">
                  <template
                    v-slot:activator="{ on }">
                    <span
                      class="caption"
                      style="cursor:pointer"
                      v-on="on">
                      <u>あなたのリクエスト状況</u>
                    </span>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        リクエスト一覧
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-container>
                      <v-card-text
                        v-if="this.allRequests.length() === 0">
                        <span>あなたからのリクエストはありません。</span>
                      </v-card-text>
                    </v-container>
                    <RequestsByTeacher
                      v-for="request in this.allRequests.get()"
                      :key="request.id"
                      :request="request"
                      @confirm="confirm(request)"
                    />
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog=false">
                        閉じる
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-text>
            </v-card>
          </v-container>
          <RequestFromParent
            v-for="request in this.requests.get()"
            :key="request.id"
            :request="request"
            @removeRequest="removeRequest(request)"
            @deleteRequest="deleteRequest(request)"
          />
        </v-col>
      </v-row>

      <v-dialog
        v-model="acceptedDialog"
        persistent
        width="350">
        <v-card>
          <v-card-title >
            リクエストを承認しました。
          </v-card-title>
         <v-container>
          承認した生徒は生徒一覧に反映されます。
         </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              @click="acceptedDialog = false">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deniedDialog"
        width="300">
        <v-card>
          <v-container>
            リクエストを拒否しました。
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="primary"
              @click="deniedDialog = false">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div
      v-else
      class="max-height">
      <Loading/>
    </div>
  </v-container>
</template>

<script>
import RequestFromParent from '@/components/organisms/teacher/RequestFromParent.vue'
import RequestsByTeacher from '@/components/organisms/teacher/RequestsByTeacher.vue'
import { firestore } from "@/repository/client/firestore.js"
import { RequestRepository } from '@/repository/RequestRepository.js'
import Loading from '@/components/organisms/Loading.vue'

export default {
  name:'Requestbox',
  components:{
    'RequestFromParent': RequestFromParent,
    'RequestsByTeacher': RequestsByTeacher,
    'Loading': Loading,
  },
  data(){
    return {
      Loading: true,
      teacher: this.$store.getters.teacher,
      requests: [],
      allRequests: [],
      acceptedDialog: false,
      deniedDialog: false,
      dialog: false,
    }
  },
  methods: {
    removeRequest(request) {
      this.requests.remove(request)
      this.acceptedDialog = true
    },
    deleteRequest(request) {
      this.requests.remove(request)
      this.deniedDialog = true
    },
    async confirm(request) {
      await this.requestRepo.delete(request)
      this.allRequests.remove(request)
    },
  },
  created: async function() {
    this.requestRepo = new RequestRepository(firestore)
    const requests = await this.requestRepo.listOfInRequest(this.teacher.uuid)
    this.requests = requests.notTeaching(this.teacher)
    this.allRequests = await this.requestRepo.listOfAllRequests(this.teacher.uuid)
    this.Loading = false
  },
}

</script>

